import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import bs4OptionBinding from '../../Bs4OptionBinding'
import Bs4GenericField from './Bs4GenericField'

export default class Bs4Tabelka extends Bs4GenericField {

  initializeFormField() {
    super.initializeFormField()
    
    console.log('...Bs4Tabelka...', this.props)
    this.bs4Option = bs4OptionBinding({
      bs4Source: 'Bs4Tabelka',
      bs4KartotekaId: this.bs4KartotekaId,
      optionId: this.props.field.idSourceReport,
      optionType:'tabelka',
      formId: this.props.field.formId,
      bs4flexframe: this.props.bs4flexframe,
      tablecols: this.props.field.tablecols,
      tablevals: this.props.field.tablevals,
      hidcolhead: this.props.field.hidcolhead,
      noSelectableCheckbox: true,
    });
  }
  
  ViewComponentField = (props) => {
    const formField = this;
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}      
    }, []);

    return (
      <FormControl id={this.props.inputId} fullWidth error={error.error} sx={{height: this.props.bs4flexframe ? '100%' : 'auto'}} >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <formField.bs4Option.ViewComponent noHeight/>        
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}